
import { useEnergyAnalysis } from '../../../hooks/useEnergyAnalysis';
import { Soknad } from '../../../types/building';

export const useEnergiplanRegistrations = (soknad?: Soknad) => {
  const { energyAnalysis: energyAnalysisSteg1, energyAnalysisLoading: energyAnalysisSteg1Loading, energyAnalysisError: energyAnalysisSteg1Error } =
    useEnergyAnalysis(soknad?.registreringForSteg1);
  const { energyAnalysis: energyAnalysisSteg2, energyAnalysisLoading: energyAnalysisSteg2Loading, energyAnalysisError: energyAnalysisSteg2Error } =
    useEnergyAnalysis(soknad?.registreringForSteg2);
  const { energyAnalysis: energyAnalysisSteg3, energyAnalysisLoading: energyAnalysisSteg3Loading, energyAnalysisError: energyAnalysisSteg3Error } =
    useEnergyAnalysis(soknad?.registreringForSteg3);

  return {
    energyAnalysisSteg1,
    energyAnalysisSteg2,
    energyAnalysisSteg3,
    energiplanRegistrationsLoading: energyAnalysisSteg1Loading || energyAnalysisSteg2Loading || energyAnalysisSteg3Loading,
    energiplanRegistrationsError: energyAnalysisSteg1Error || energyAnalysisSteg2Error || energyAnalysisSteg3Error
  };
};
